(function () {
  const initAnnouncementTicker = (section) => {
    if (!section) return;

    const ticker = section.querySelector(".announcement-bar__ticker");
    if (!ticker) return;

    const speed = parseInt(ticker.dataset.speed) || 15000;
    const pauseOnHover = ticker.dataset.pauseOnHover === "true";

    const swiper = new Swiper(ticker.querySelector(".swiper"), {
      slidesPerView: "auto",
      loop: true,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      allowTouchMove: false,
      spaceBetween: 32,
    });

    // Drive movement via RAF — gives instant pause without CSS transition bleed-through
    const slideWidth = (swiper.slides[0]?.offsetWidth || 200) + 32; // + spaceBetween
    const pxPerMs = slideWidth / speed;

    let lastTime = null;
    let running = true;

    function step(ts) {
      if (lastTime !== null && running) {
        const delta = Math.min(ts - lastTime, 50); // cap to avoid jumps after tab switch
        swiper.setTranslate(swiper.getTranslate() - pxPerMs * delta);
        swiper.loopFix();
      }
      lastTime = ts;
      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);

    if (pauseOnHover) {
      const bar = ticker.closest(".announcement-bar") || ticker;
      bar.addEventListener("mouseenter", () => {
        running = false;
      });
      bar.addEventListener("mouseleave", () => {
        lastTime = null; // reset to avoid jump from time accumulated while paused
        running = true;
      });
    }
  };

  initAnnouncementTicker(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initAnnouncementTicker(event.target);
  });
})();
